import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";

import { baseUrl } from "app/utils/constants/paths";
const initialState = {
  loading: false,
  forgotPasswordLoader: false,
  resetPasswordLoader: false,
};

export const signInThunk = createAsyncThunk(
  "user/signInThunk",
  async (payload) => {
    try {
      const response = await Axios.post(`${baseUrl}/auth/signin`, payload);
      //console.log('response', response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const forgotPasswordThunk = createAsyncThunk(
  "user/forgotPasswordThunk",
  async (payload) => {
    try {
      const response = await Axios.post(
        `${baseUrl}/auth/forgotpassword`,
        payload
      );
      //console.log('response', response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const updateResetPasswordThunk = createAsyncThunk(
  "user/updateResetPasswordThunk",
  async (payload) => {
    try {
      const response = await Axios.post(
        `${baseUrl}/auth/updatenewpassword`,
        payload
      );
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const validateResetPasswordToken = createAsyncThunk(
  "user/validateResetPasswordToken",
  async (payload) => {
    try {
      const response = await Axios.post(
        `${baseUrl}/auth/validateresetpasswordtoken`,
        payload
      );
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
const Login = createSlice({
  name: "login",
  initialState,
  reducers: {
    logOut(state, action) {
      localStorage.clear();
      window.location.href = `/login`;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(signInThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(signInThunk.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload.data.success === true) {
          let resultData = action.payload.data;
          // localStorage.setItem("userName", resultData.user_data.name);
          // localStorage.setItem("email", resultData.user_data.email);
          // localStorage.setItem('isSysAdmin', resultData.user_data.is_sys_admin);
          localStorage.setItem("access_token", resultData.access_token);
          localStorage.setItem("refresh_token", resultData.refresh_token);
        } else if (action.payload.data.error === true) {
        }
      })
      .addCase(signInThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(forgotPasswordThunk.pending, (state) => {
        state.forgotPasswordLoader = true;
      })
      .addCase(forgotPasswordThunk.fulfilled, (state, action) => {
        state.forgotPasswordLoader = false;
      })
      .addCase(forgotPasswordThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.forgotPasswordLoader = false;
      })
      .addCase(validateResetPasswordToken.pending, (state) => {
        state.resetPasswordLoader = true;
      })
      .addCase(validateResetPasswordToken.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload.data.success === true) {
          let resultData = action.payload.data;
        } else if (action.payload.data.error === true) {
        }
        state.resetPasswordLoader = false;
      })
      .addCase(validateResetPasswordToken.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(updateResetPasswordThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateResetPasswordThunk.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload.data.success === true) {
          let resultData = action.payload.data;
        } else if (action.payload.data.error === true) {
        }
      })
      .addCase(updateResetPasswordThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      });
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = Login;
// Extract and export each action creator by name
export const { logOut } = actions;
// Export the reducer, either as a default or named export
export default reducer;
